<nav-item label="Room Content"  [hideChevronRight]="true" [ngClass]="{'active': isActive()}">
    <svg-icon key="room-content" fontSize="1.5rem"></svg-icon>
</nav-item>